import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchCurrentUser } from '../redux/authSlice';
import type { AppDispatch } from '../redux';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUser = async () => {
      try {
        await dispatch(fetchCurrentUser()).unwrap();
      } catch (error:any) {
        console.log(error)
        navigate('/login', { replace: true });
      } finally {
        setLoading(false);
      }
    };

    checkUser();
  }, [dispatch, navigate]);

  if (loading) {
    return null;
  }

  return <>{children}</>;
};

export default PrivateRoute;
